import React, { lazy, Suspense, memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConfigProvider } from "antd";
import Loading from "components/shared-components/Loading";
import { lightTheme, darkTheme } from "configs/ThemeConfig";
import { resources } from "lang";
import useBodyClass from "utils/hooks/useBodyClass";
import useFavicon from "utils/hooks/useFavicon";
import Routes from "routes";
import TxtFileService from "services/TxtFileService";
import settingsService from "services/settingsService";
// import fetch from "auth/FetchInterceptor";
import { saveAdminSettings } from "store/slices/authSlice";
import { RefreshProvider } from "./RefreshContext";

const AppLayout = lazy(() => import("./AppLayout"));
const AuthLayout = lazy(() => import("./AuthLayout"));

const Layouts = () => {
  const token = useSelector((state) => state.auth.token);
  const blankLayout = useSelector((state) => state.theme.blankLayout);
  const { adminSettings } = useSelector((state) => state.auth);

  const Layout = token && !blankLayout ? AppLayout : AuthLayout;

  const locale = useSelector((state) => state.theme.locale);

  const direction = useSelector((state) => state.theme.direction);

  const currentTheme = useSelector((state) => state.theme.currentTheme);

  const currentAppLocale = resources[locale];

  useBodyClass(`dir-${direction}`);

  // Update favicons dynamically based on admin settings
  useFavicon(adminSettings?.faviconIcons);

  // State to store TinyMCE key from settings API
  const [tinymceKey, setTinymceKey] = useState();
  // "5uogqwqjxkyrr9dga3eke9xxf6cw8ngtkhm3qlyo0ud5rikq"

  // Load TinyMCE script dynamically using key from settings API
  useEffect(() => {
    if (!tinymceKey) {
      return undefined;
    }

    const scriptSrc = `https://cdn.tiny.cloud/1/${tinymceKey}/tinymce/5/tinymce.min.js`;
    // const existingScript = document.querySelector(
    //   'script[data-tinymce-key="true"]'
    // );

    // if (existingScript) {
    //   if (existingScript.getAttribute("src") === scriptSrc) {
    //     return undefined;
    //   }
    //   existingScript.remove();
    // }

    const script = document.createElement("script");
    script.src = scriptSrc;
    script.referrerPolicy = "origin";
    // script.dataset.tinymceKey = "true";
    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, [tinymceKey]);

  const themeConfig =
    currentTheme === "light" ? { ...lightTheme } : { ...darkTheme };

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchAdminSettings = async () => {
      try {
        // setLoading(true)
        const { data } = await TxtFileService.getTxtFileLinks();

        if (data.generalTxt) {
          //   const settings = await fetch({
          //     url: data.generalTxt,
          //     method: "get",
          //   });
          const generalTxtUrl = `${data.generalTxt}${
            data.generalTxt.includes("?") ? "&" : "?"
          }_=${Date.now()}`;
          const [generalData] = await Promise.all([
            fetch(generalTxtUrl).then((res) => res.json()),
          ]);
          if (generalData) {
            dispatch(
              saveAdminSettings(generalData?.adminSettings?.[0] || null)
              //   saveAdminSettings({
              //     adminSettings: generalData?.adminSettings?.[0] || null,
              //   })
            );
            if (generalData?.adminSettings?.[0]?.tinymceKey) {
              setTinymceKey(generalData?.adminSettings?.[0].tinymceKey);
            }
          }
          console.log("666 settings", generalData);
        }
      } catch (e) {
        console.error(e);
      } finally {
        // setLoading(false)
      }
    };
    fetchAdminSettings();
  }, []);

  return (
    <ConfigProvider
      theme={themeConfig}
      direction={direction}
      locale={currentAppLocale.antd}
    >
      <Suspense fallback={<Loading cover="content" />}>
        <RefreshProvider>
          <Layout>
            <Routes />
          </Layout>
        </RefreshProvider>
      </Suspense>
    </ConfigProvider>
  );
};

export default memo(Layouts);
